import { Link } from 'react-router-dom';
import Icon from '../components/Icons';
import { formatINR, formatPrice, serviceOf } from '../data/common';
import { activeCurrency, isConverted } from '../currency/currencyStore';
import { countryName } from '../data/countries';

export const flowSteps = ['Search', 'Select', 'Review & Pay', 'Confirmation'];

export function Stepper({ current }) {
  return (
    <ol className="stepper">
      {flowSteps.map((s, i) => (
        <li key={s} className={i < current ? 'done' : i === current ? 'current' : ''}>
          <span className="step-dot">{i < current ? <Icon name="check" size={12} strokeWidth={3} /> : i + 1}</span>
          <span className="step-label">{s}</span>
        </li>
      ))}
    </ol>
  );
}

export function FlowBand({ title, step, back }) {
  return (
    <div className="flow-band">
      <div className="container flow-band-inner">
        <div>
          {back && <Link to={back.to} className="flow-back"><Icon name="right" size={14} className="flip" /> {back.label}</Link>}
          <h1>{title}</h1>
        </div>
        {step != null && <Stepper current={step} />}
      </div>
    </div>
  );
}

export function FareBreakdown({ fare }) {
  return (
    <div className="fare-breakdown">
      {fare.lines.map(([label, amount]) => (
        <div key={label} className="summary-line"><span>{label}</span><span>{formatPrice(amount)}</span></div>
      ))}
      {fare.convenienceFee > 0 && (
        <div className="summary-line">
          <span>Convenience fee{fare.convenienceFeeNote && <small className="muted fee-note">{fare.convenienceFeeNote}</small>}</span>
          <span>{formatPrice(fare.convenienceFee)}</span>
        </div>
      )}
      {fare.discount > 0 && (
        <div className="summary-line text-primary"><span>Promo {fare.coupon}</span><span>−{formatPrice(fare.discount)}</span></div>
      )}
      <div className="summary-line total"><span>Total amount</span><b>{formatPrice(fare.total)}</b></div>
      {isConverted() && (
        <div className="summary-line charge-line">
          <span>Charged in INR<small className="muted fee-note">{activeCurrency().code} amounts are approximate</small></span>
          <b>{formatINR(fare.total)}</b>
        </div>
      )}
    </div>
  );
}

export const travellerName = (t) => [t.title, t.firstName, t.lastName].filter(Boolean).join(' ');

const extraFields = [['dob', 'Date of birth'], ['age', 'Age'], ['gender', 'Gender'], ['passport', 'Passport no.'], ['passportExpiry', 'Passport expiry'], ['nationality', 'Nationality'], ['pan', 'PAN'], ['idNumber', 'ID no.'], ['nominee', 'Nominee'], ['nomineeRelation', 'Relationship'], ['university', 'University'], ['policyNumber', 'Policy']];
// Shown on confirmation and booking pages, which can be printed or shared.
const maskPan = (pan) => `XXXXX${String(pan).slice(5).toUpperCase()}`;

export function TravellerTable({ travellers }) {
  return (
    <table className="data-table">
      <thead><tr><th>#</th><th>Name</th><th>Type</th><th>Details</th></tr></thead>
      <tbody>
        {travellers.map((t, i) => (
          <tr key={i}>
            <td>{i + 1}</td>
            <td><b>{travellerName(t)}</b></td>
            <td>{t.type}</td>
            <td className="muted small">{extraFields.filter(([k]) => t[k]).map(([k, l]) => `${l}: ${k === 'nationality' ? countryName(t[k]) : k === 'pan' ? maskPan(t[k]) : t[k]}`).join(' · ') || '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function ModuleIcon({ module, size = 22 }) {
  return <span className={`module-icon mi-${module}`}><Icon name={module} size={size} /></span>;
}

export function ExpiredSelection({ module }) {
  const s = serviceOf(module);
  return (
    <div className="container section empty">
      <span className="empty-icon"><Icon name="clock" size={34} /></span>
      <h2>Your session has expired</h2>
      <p>Prices may have changed. Please search again to continue booking.</p>
      <Link to={s.path} className="btn btn-primary">Search {s.label}</Link>
    </div>
  );
}
